import { Button } from 'antd';
import linkImage from 'assets/images/link.svg';
import './LinkButton.scss';

interface LinkButtonProps {
  onClick: () => void;
  title: string;
}

const LinkButton: React.FC<LinkButtonProps> = ({ title, onClick }) => {
  return (
    <Button
      type="link"
      onClick={onClick}
      className="vls-link-button"
      icon={<img src={linkImage}></img>}
      iconPosition="end"
    >
      {title}
    </Button>
  );
};

export default LinkButton;
